import React from "react";
import { habitacional, SeguroEmpresarial } from "../../../../../config/links";
import { ReactComponent as PersonIcon } from "../../../../../assets/images/icons/person-icon.svg";
import { links } from "../../../../../config";

export const menuLinks = [
  {
    label: "Início",
    href: "/",
  },
  {
    label: "Para você",
    href: habitacional.home,
    submenu: [
      { label: "Seguro Habitacional", href: links.habitacional.home },
      { label: "Seguro Residencial", href: links.residencial.home },
      { label: "divider", isDivider: true },
      {
        label: (
          <div className="column-start">
            Seguro Auto <br /> <span>(até 21/05/2021)</span>
          </div>
        ),
        href: links.seguroAutoAntigo,
      },
      {
        label: (
          <div className="column-start">
            Seguro Auto <br /> <span>(a partir de 22/05/2021)</span>
          </div>
        ),
        href: links.seguroAutoNovo,
      },
      { label: "Seguro Saúde", href: links.seguroSaude },
    ],
  },
  {
    label: "Para sua empresa",
    href: SeguroEmpresarial,
    submenu: [
      {
        label: "MEI e pequenas empresas",
        href: links.empresarial.seguroEmpresarial,
      },
      {
        label: "Médias e Grandes Empresas",
        href: links.empresarial.seguroMultirrisco,
      },
      { label: "divider", isDivider: true },
      {
        label: " Lotérico e CCA",
        href: links.empresarial.seguroLoterico,
      },
      {
        label: "Seguro Saúde Empresarial",
        href: links.empresarial.seguroSaude,
      },
    ],
  },
  {
    label: "Sobre nós",
    href: links.sobreNos.home,
  },
  {
    label: "Atendimento",
    href: links.atendimento,
  },
  {
    label: (
      <>
        <div>
          <PersonIcon /> Fazer login
        </div>
      </>
    ),
    href: links.areaLogada,
    isExternalLink: true,
    isOnlyMobile: true,
  },
];
